export const CONFIGSOBJECTSEND_SET_LIST_DATA = 'CONFIGSOBJECTSEND_SET_LIST_DATA';
export const CONFIGSOBJECTSEND_SET_LIST_META = 'CONFIGSOBJECTSEND_SET_LIST_META';
export const CONFIGSOBJECTSEND_TITLE = 'Cấu hình đối tượng gửi';